import { ReactNode, SelectHTMLAttributes, useId } from 'react';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Muted 13px label shown inside the box, before the select. */
  label: string;
  children: ReactNode;
  /** Class for the outer bordered box. */
  boxClassName?: string;
}

/**
 * Design `.field` with a select: one 44px bordered box holding a muted 13px label and a
 * borderless 14px select (top-bar Section picker, long free-choice lists).
 */
export default function InlineSelect({ label, children, boxClassName = '', className = '', id, ...rest }: Props) {
  const auto = useId();
  const selectId = id ?? auto;
  return (
    <span className={`inline-flex min-h-[44px] items-center gap-2 rounded-[12px] border border-line-strong bg-surface px-3.5 focus-within:outline focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-slate ${boxClassName}`}>
      <label htmlFor={selectId} className="whitespace-nowrap text-[13px] text-muted">{label}</label>
      <select id={selectId} {...rest}
        className={`min-w-0 cursor-pointer border-0 bg-transparent py-0 pl-0 pr-7 text-sm text-ink shadow-none outline-none ring-0 focus:outline-none focus:ring-0 ${className}`}>
        {children}
      </select>
    </span>
  );
}
